<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-excavator</v-icon>
                    Listado de Clientes
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="12" sm="8" md="6">
                            <v-text-field dense v-model="filtrocliente" label="Filtrar por Nombre de Cliente">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="3">
                            <v-btn color="success" @click.stop="cargardatos()">Buscar</v-btn>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-btn color="primary" dark @click="ver()">
                            Listado de Obras
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog" persistent max-width="600px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark v-bind="attrs" v-on="on" @click="cargarnumcliente()">
                                    Nuevo Cliente
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5">Agregar Cliente N° {{ numcliente }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field label="Nombre del Cliente" v-model="nomcliente"
                                                    required></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field v-model="codigo" label="Código ICSSA"></v-text-field>
                                            </v-col>

                                        </v-row>
                                    </v-container>

                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="dialog = false">
                                        Cerrar
                                    </v-btn>
                                    <v-btn color="blue darken-1" text @click="guardarcliente()">
                                        Guardar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card>
                <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                    :items-per-page="200" :footer-props="{
                        itemsPerPageText: 'Clientes por página',
                    }">
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs"
                                    @click.stop="ver(item)">
                                    mdi-eye
                                </v-icon>
                            </template>
                            <span>ver obras</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small color="orange" class="mr-2" v-on="on" v-bind="attrs"
                                    @click.stop="agregar(item)">
                                    mdi-wrench
                                </v-icon>
                            </template>
                            <span>agregar obra</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small color="purple" class="mr-2" v-on="on" v-bind="attrs"
                                    @click.stop="editar(item)">
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>editar cliente</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
            <Ver :visible="showVer" :numcliente="editedItem.numcliente" :nomcliente="editedItem.nomcliente"
                @close="showVer = false">
            </Ver>
            <Agregar :visible="showAgregar" :numcliente="editedItem.numcliente" :nomcliente="editedItem.nomcliente"
                @close="showAgregar = false">
            </Agregar>
            <Editar :visible="showEditar" :numcliente="editedItem.numcliente" :nomcliente="editedItem.nomcliente"
                :codigo="editedItem.codigo" @close="showEditar = false">
            </Editar>
        </v-app>
    </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
    display: none;
}
</style>

<script>
import axios from "../../../axios-auth";
import Editar from "./Editarcliente.vue";
import Ver from "../Administracion/Listadoobra.vue";
import Agregar from "../Administracion/Nuevaobra.vue";
export default {
    components: { Editar, Ver, Agregar },
    data: (vm) => ({
        showAgregar: false,
        showEditar: false,
        showVer: false,
        editedItem: {},
        editedIndex: -1,
        filtrocliente: "",
        numcliente: "",
        nomcliente: "",
        codigo: "",
        clientes: [],
        listado: [],
        dialog: false,
        obrasactivas: false,
        headers: [
            { text: "N° Cliente", align: "center", sortable: false, value: "numcliente" },
            { text: "Cliente", value: "nomcliente" },
            { text: "Código", align: "center", sortable: false, value: "codigo" },
            { text: "Acciones", align: "center", sortable: false, value: "actions" },
        ],
    }),

    computed: {
        show: {
            get() {
                this.cargardatos();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$refs.form.resetValidation();
                    //this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        cargarnumcliente() {
            let self = this;
            axios
                .get("/Ingenieria/CodigoCliente", {})
                .then((response) => {
                    self.numcliente = response.data;
                })
                .catch((error) => {
                    self.numcliente = "";
                });
        },
        cargardatos() {
            let self = this;
            let filtrocliente = this.filtrocliente;
            axios
                .get("/Ingenieria/Listadoclientes", {
                    params: {
                        filtrocliente: filtrocliente,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    self.listado = [];
                });
        },

        guardarcliente() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Cliente",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var datos = {
                        numcliente: this.numcliente,
                        nomcliente: this.nomcliente,
                        codigo: this.codigo,

                    };

                    let self = this;
                    axios
                        .post("/Ingenieria/GuardarCliente", datos)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: "Cliente guardado con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            setTimeout(() => {
                                self.$router.push({ name: "IngListadoCliente" });
                            }, 2000);
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },
        vaciarListado() {
            this.listado = [];
            this.numcliente = "";
            this.nomcliente = "";
            this.codigo = "";
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 1500,
            });
        },

        editar(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },
        ver(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showVer = true;
        },
        agregar(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showAgregar = true;
        },
    },
};
</script>